import React, { JSX } from 'react';
import { Flex, Select, Text } from '@chakra-ui/react';

export type OptionItem = {
  value: string;
  label: React.ReactNode;
};

type StatusFilterSelectProps = {
  label: React.ReactNode;
  value: string;
  onChange: (value: string) => void;
  options: OptionItem[];
  size?: 'sm' | 'md' | 'lg';
  width?: string | number;
  containerProps?: React.ComponentProps<typeof Flex>;
};

export const StatusFilterSelect = ({
  label,
  value,
  onChange,
  options,
  size = 'sm',
  width = '180px',
  containerProps,
}: StatusFilterSelectProps): JSX.Element => {
  return (
    <Flex alignItems="center" gap={2} {...containerProps}>
      <Text>{label}</Text>
      <Select size={size} width={width} value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </Select>
    </Flex>
  );
};
